function LoadingScreen({ isLoading, fallback, children }) {
  return isLoading ? fallback : children;
}

export default LoadingScreen;
